import modalComponent from '../components/Modal';

const render = (message, btnClose = true) => {
  const fragment = document.createElement('div');
  fragment.innerHTML = modalComponent(message, btnClose);
  document.body.insertAdjacentElement('afterbegin', fragment);

  const $modal = document.querySelector('.xpi__modal');

  $modal.style.opacity = 0;
  setTimeout(() => {
    $modal.style.opacity = 1;
  }, 20);
  btnClose ? logout() : '';
}

const logout = () => {
  const $btn_close = document.querySelector('.xpi__modal__close');

  $btn_close.addEventListener('click', () => {
    if(window.xpSession)
      window.xpSession.logout;
    else
      window.location.reload(true);
  });
};

export default {
  render,
  logout,
}
